<template lang="html">
  <el-row class="flex1 col border-b1 border-style-dotted border-color-ccc">
    <el-row class="border-b1 border-style-dotted border-color-ccc center-ud bg-999">
      <el-col :span="12" class="fs12 pdl10 ">
        <span>输入区：</span>
        <el-button type="text" @click="dialogVisible=true">查看模板</el-button>
        <el-dialog
          title="例题示范"
          :visible.sync="dialogVisible"
          width="30%">
          <div>
            <div class="title pdb10">
              输入规范
            </div>
            <p>
              1、题号以<span style="color:#F00">1.</span>格式。<br>
              2、选项以<span style="color:#F00">A、</span>格式，支持<span style="color:#F00">[A-F]</span>选项。<br>
              3、答案中请勿加分隔符或空格，文字过长勿手动加回车<br>
              4、判断题答案格式为<span style="color:#F00">对</span>、<span style="color:#F00">错</span>
            </p>
            <div class="title pd-tb10">
              输入范例
            </div>
            <p v-if="Type == 2">
              <span>1.国际象棋起源于英国吗？</span><br>
              <span>答案:对</span><br>
              <span>解析:请仔细阅读交规<span style="color:#F00">(若无解析本行可不填)</span></span>
            </p>
            <p v-if="Type == 1">
              <span>1.驾驶人有下列哪种违法行为一次记6分？</span><br>
              <span>A、使用其他车辆行驶证</span><br>
              <span>B、饮酒后驾驶机动车</span><br>
              <span>C、车速超过规定时速50%以上</span><br>
              <span>D、违法占用应急车道行驶</span><br>
              <span>答案:ABCD</span><br>
              <span>解析:请仔细阅读交规<span style="color:#F00">(若无解析本行可不填)</span></span>
            </p>
            <p  v-if="Type == 0">
              <span>1.驾驶人有下列哪种违法行为一次记6分</span><br>
              <span>A、使用其他车辆行驶证</span><br>
              <span>B、饮酒后驾驶机动车</span><br>
              <span>C、车速超过规定时速50%以上</span><br>
              <span>D、违法占用应急车道行驶</span><br>
              <span>答案:D</span><br>
              <span>解析:请仔细阅读交规<span style="color:#F00">(若无解析本行可不填)</span></span>
            </p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
      </el-col>
      <el-col :span="12" class="fs12 pdl10">
        <span>检查区：</span>
      </el-col>
    </el-row>
    <el-row class="row flex1">
      <el-col :span="12" class="textarea-group">
        <div class="textarea-wrap allHeight pd-tb10 none" @scroll="scrollHeight" ref="textarea-wrap">
          <div :key="index" v-for="(item,index) in TextWrap">
            {{index+1}}
          </div>
        </div>
        <textarea class="text-input" ref="text-input" cols="100" @scroll="scrollHeight"  v-model="TextInput" wrap="hard" placeholder="请将当前所选题型的所有试题复制到这里" ></textarea>
      </el-col>
      <el-main class="flex1 bg-eee overflowXHidden">
        <!-- 多选 -->
        <el-row class="pd10 bg-fff mg-b10" v-if="Type==1" :key="index" v-for="(item,index) in FormatData">
          <el-row class="pd-tb20 fs18 color-333">
            <span class="fs20 mg-r10 fontweightbold color-theam1">{{item.key}}.</span>{{item.stem}}
          </el-row>
          <el-row>
            <el-col :offset="1" :span="23">
              <el-checkbox-group v-model="item.answer">
                <el-row :key="index" v-for="(option,index) in item.option" class="pd-tb10">
                  <el-checkbox :label="option.order">{{option.order}}、{{option.text}}</el-checkbox>
                </el-row>
              </el-checkbox-group>
            </el-col>
          </el-row>
          <el-row v-if="item.error!=undefined" class="border-radio5 bg-red fontweightbold">
            <el-col :offset="1" :span="23" class="pd-tb10 fs18 color-fff">
              {{item.error['msg']}}
            </el-col>
          </el-row>
          <el-row v-if="item.analysis">
            <el-col :offset="1" :span="23" class="pd-tb20 fs18 color-333">
              <span class="color-adc0d4">解析：</span>{{item.analysis}}
            </el-col>
          </el-row>

        </el-row>
        <!-- 单选 -->
        <el-row class="pd10 bg-fff mg-b10" v-if="Type==0" :key="index" v-for="(item,index) in FormatData">
          <el-row class="pd-tb20 fs18 color-333">
            <span class="fs20 mg-r10 fontweightbold color-theam1">{{item.key}}.</span>{{item.stem}}
          </el-row>
          <el-row>
            <el-col :offset="1" :span="23">
              <el-radio-group v-model="item.answer">
                <el-row :key="index" v-for="(option,index) in item.option" class="pd-tb10">
                  <el-radio :label="option.order">{{option.order}}、{{option.text}}</el-radio>
                </el-row>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row v-if="item.error!=undefined" class="border-radio5 bg-red fontweightbold">
            <el-col :offset="1" :span="23" class="pd-tb10 fs18 color-fff">
              {{item.error['msg']}}
            </el-col>
          </el-row>
          <el-row v-if="item.analysis">
            <el-col :offset="1" :span="23" class="pd-tb20 fs18 color-333">
              <span class="color-adc0d4">解析：</span>{{item.analysis}}
            </el-col>
          </el-row>

        </el-row>
        <!-- 判断 -->
        <el-row class="pd10 bg-fff mg-b10" v-if="Type==2" :key="index" v-for="(item,index) in FormatData">
          <el-row class="pd-tb20 fs18 color-333">
            <span class="fs20 mg-r10 fontweightbold color-theam1">{{item.key}}.</span>{{item.stem}}
          </el-row>
          <el-row v-if="item.error==undefined||item.error['code']!=4&&item.error['code']!=2">
            <el-col :offset="1" :span="23" class="pd-tb10 fs18 color-333">
              <span class="color-adc0d4">答案：</span>{{item.answer?"对":"错"}}
            </el-col>
          </el-row>
          <el-row v-if="item.error!=undefined" class="border-radio5 bg-red fontweightbold">
            <el-col :offset="1" :span="23" class="pd-tb10 fs18 color-fff">
              {{item.error['msg']}}
            </el-col>
          </el-row>
          <el-row v-if="item.analysis">
            <el-col :offset="1" :span="23" class="pd-tb10 fs18 color-333">
              <span class="color-adc0d4">解析：</span>{{item.analysis}}
            </el-col>
          </el-row>

        </el-row>
      </el-main>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'QuesEditor',
  data () {
    return {
      TextWrap: [1],
      TextInput: '',
      FormatData: '',
      ScrollHeight: 1,
      Type: 0, // 0-单选题 1-多选题 2-判断题
      stateCode: {
        0: { code: 0, msg: 'success' },
        1: { code: 1, msg: '缺少答案和解析' },
        2: { code: 2, msg: '多余字符或未写答案' },
        3: { code: 3, msg: '缺少解析' },
        4: { code: 4, msg: '答案不符合规范' },
        5: { code: 5, msg: '多选题应有至少两项答案' }
      },
      dialogVisible: false
    }
  },
  props: ['editorType', 'isClear'],
  created () {
    let _self = this
  },
  methods: {
    scrollHeight (event) {
      let _self = this
      _self.$refs['textarea-wrap'].scrollTop = event.target.scrollTop
      _self.$refs['text-input'].scrollTop = event.target.scrollTop
    },
    // 去除空行
    delEmpty (arr) {
      let new_arr = arr.filter(item => {
        if (item !== '' || typeof (item) !== 'undefined') {
          return item
        }
      })
      return new_arr
    },
    grouping (arr) {
      let _self = this
      let stem = []

      arr.map((item, index) => {
        if (/^[0-9]+\./.test(item)) {
          stem.push({
            stem: item.substring(item.indexOf('.') + 1),
            row: index,
            key: item.substring(0, item.indexOf('.'))
          })
        }
      })

      for (let i = 0; i < stem.length; i++) {
        if (stem[i + 1]) {
          stem[i]['main'] = arr.slice(stem[i]['row'] + 1, stem[i + 1]['row'])
        } else {
          stem[i]['main'] = arr.slice(stem[i]['row'] + 1)
        }
      }

      for (let i in stem) {
        if (stem[i]['main'] <= 0) {
          stem[i]['error'] = _self.stateCode['2']
        }
      }

      return stem
    },
    // 判断题解析数据
    decJudeg (obj) {
      let _self = this

      obj.forEach(item => {
        if (item['error'] == undefined) {
          item['main'].forEach(sub_item => {
            if (/^答案[\：|\:]/i.test(sub_item)) {
              if (sub_item.substring(3) !== '错' && sub_item.substring(3) !== '对') {
                item['error'] = _self.stateCode['4']
              } else {
                item['answer'] = sub_item.substring(3) === '对'
              }
            } else if (/^解析[\：|\:]/i.test(sub_item)) {
              item['analysis'] = sub_item.substring(3)
            } else {
              item['error'] = _self.stateCode['2']
            }
          })
        }
      })

      obj.forEach(item => {
        if (item['answer'] == undefined) {
          item['error'] = item['error'] || _self.stateCode['2']
        }
      })

      return obj
    },
    // 多选题解析数据
    decHdMult (obj) {
      let _self = this
      let answerArr = ['A', 'B', 'C', 'D', 'E', 'F']
      let answerList = []
      obj.forEach(item => {
        if (item['error'] == undefined) {
          item['option'] = []
          item['main'].forEach(sub_item => {
            if (/^[A-F]\、/i.test(sub_item)) {
              answerList.push(sub_item.substring(0, 1))
              item['option'].push({
                order: sub_item.substring(0, 1).toUpperCase(),
                text: sub_item.substring(2)
              })
            } else if (/^答案[\：|\:]/i.test(sub_item)) {
              if (sub_item.substring(3).replace(' ', '').length < 2) {
                item['error'] = _self.stateCode['5']
              } else {
                [...sub_item.substring(3)].forEach(i => {
                  i = i.toUpperCase()
                  if (!answerList.includes(i)) {
                    item['error'] = _self.stateCode['4']
                  }
                })
                item['answer'] = [...sub_item.substring(3).toUpperCase()]
              }
            } else if (/^解析[\：|\:]/i.test(sub_item)) {
              item['analysis'] = sub_item.substring(3)
            } else {
              item['error'] = _self.stateCode['2']
            }
          })
        }
      })

      obj.forEach(item => {
        if (item['answer'] == undefined) {
          item['error'] = item['error'] || _self.stateCode['2']
        }
      })

      return obj
    },
    // 单选题解析数据
    decHdSingle (obj) {
      let _self = this
      let answerArr = ['A', 'B', 'C', 'D', 'E', 'F']
      let answerList = []
      obj.forEach(item => {
        if (item['error'] == undefined) {
          item['option'] = []
          item['main'].forEach(sub_item => {
            if (/^[A-F]\、/i.test(sub_item)) {
              answerList.push(sub_item.substring(0, 1))
              item['option'].push({
                order: sub_item.substring(0, 1).toUpperCase(),
                text: sub_item.substring(2)
              })
            } else if (/^答案[\：|\:]/i.test(sub_item)) {
              if (sub_item.substring(3).replace(' ', '').length > 1) {
                item['error'] = _self.stateCode['4']
              } else {
                [...sub_item.substring(3)].forEach(i => {
                  i = i.toUpperCase()
                  if (!answerList.includes(i)) {
                    item['error'] = _self.stateCode['4']
                  }
                })
                item['answer'] = sub_item.substring(3).toUpperCase()
              }
            } else if (/^解析[\：|\:]/i.test(sub_item)) {
              item['analysis'] = sub_item.substring(3)
            } else {
              item['error'] = _self.stateCode['2']
            }
          })
        }
      })

      obj.forEach(item => {
        if (item['answer'] == undefined) {
          item['error'] = item['error'] || _self.stateCode['2']
        }
      })
      return obj
    },
    formatData (val) {
      let _self = this
      let FormatData = null
      let Group = null

      FormatData = _self.delEmpty(val.split('\n'))
      Group = _self.grouping(FormatData)

      if (_self.Type === 2) {
        FormatData = _self.decJudeg(Group)
      } else if (_self.Type === 0) {
        FormatData = _self.decHdSingle(Group)
      } else if (_self.Type === 1) {
        FormatData = _self.decHdMult(Group)
      }

      return FormatData
    },
    clearTextarea () {
      let _self = this
      _self.TextInput = ''
      _self.$emit('clearTextarea', 'success')
    }
  },
  watch: {
    TextInput (val, oldval) {
      let _self = this
      _self.TextWrap = val.split('\n')
      _self.FormatData = _self.formatData(val)
      _self.$emit('handleEditor', _self.FormatData)
    },
    editorType: {
      handler (val) {
        let _self = this
        console.log(val)
        _self.Type = Number(val)
      },
      immediate: true
    },
    isClear: {
      handler (val) {
        let _self = this
        if (_self.isClear) {
          _self.clearTextarea()
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.none{
  display: none;
}
.overflowXScroll{
  overflow-x: scroll;
}
.overflowXHidden{
  overflow-x: hidden;
}
.textarea-group{
  position: relative;
  border-right: 1px dotted #ccc;
}
.title{
  font-size: 20px;
  color: #409EFF;
}
.textarea-wrap{
  width: 25px;
  border-right: 1px solid #eee;
  position: absolute;
  color: #ffffff;
  background: #02152a;
  overflow: scroll;
  div{
    width: 25px;
    height: 25px;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &::-webkit-scrollbar {
    display: none;
  }
}
.text-input{
  outline: none;
  border: none;
  padding: 10px;
  width: 100%;
  padding-left: 35px;
  line-height: 25px;
  height: 100%;
  white-space: pre-wrap;
  resize: none;
}
.option{
      font-size: 14px;
    margin: 15px 5px;
}
.bg-eee{
      background: #eee;
}
.border-radio10 {
    border-radius: 10px;
}
</style>
